import React, {useState, useEffect} from "react";
import {Modal} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Select from "react-select";
import addIcon from "../../../asset/images/add_icon.svg";
import axios from "axios";
import {toast} from "react-toastify";
import {AESEncryption, ApiResDecrypt} from "../../../CommonMethhods/CommonMethods";

function RejectionTypeComp(props) {
    const {URL, mainType} = props;
    const [paN, setPaN] = useState([]);
    const [bank, setBank] = useState([]);
    const [address, setAddress] = useState([]);
    const [other, setOther] = useState([]);
    const [show, setShow] = useState(false);
    const [objPopUp, setObjPopUp] = useState(false);
    const [pan, setPan] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [addressPr, setAddressPr] = useState([]);
    const [others, setOthers] = useState([]);
    const [typeofObjection, setTypeOfObjection] = useState("");
    const [objection, setObjection] = useState("");
    const storeToken = localStorage.getItem("ssoToken");
    if (storeToken == null) {
        window.location.replace("/");
    }
    let navigate = useNavigate();

    const handleOnChange = () => {
        if (paN.length !== 0 || bank.length !== 0 || address.length !== 0 || other.length) {
            setShow(true);
            if (paN.length !== 0) {
                let panArra = paN;
                let panValue = [];
                for (let data of panArra) {
                    panValue.push(data.value);
                }
            }
        } else {
            toast.error("Please Select at least one option");
        }
    };
    const docType = [{name: "PAN"}, {name: "Bank Details"}, {name: "Address proof"}, {name: "Others"}];

    function UserTypeChange(e) {
        setTypeOfObjection(e.target.value);
    }

    function addObjection(e) {
        setObjection(e.target.value);
    }

    function AddNewObjection() {
        if (typeofObjection !== "" && objection !== "") {
            AddObject();
            setObjPopUp(false);
        } else {
            setObjPopUp(true);
        }
    }

    const AddObject = async () => {
        try {
            const encResponse = await axios.post(
                `${URL.addObjections}`,
                AESEncryption({
                    type: typeofObjection,
                    objection: objection,
                }),

                {
                    headers: {
                        "content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                        reserv: 1,
                    },
                }
            );
            let response = ApiResDecrypt(encResponse.data);
            const data = await response;
            if (data.data == "Data saved") {
                toast.success(data.data);
                GetObjections();
            } else {
                toast.error(data.message);
            }
        } catch (err) {
            console.log("Error", err.message);
        }
    };

    const processResponse = (data) => {
        const finalRes = [];
        if (data.length > 0) {
            data.map((data, index) => {
                let Object = {value: data.id, label: data.reason};
                finalRes.push(Object);
            });
        }
        return finalRes;
    };

    const GetObjections = async () => {
        try {
            const encResponse = await axios.get(
                `${URL.getObjections}`,

                {
                    headers: {
                        "content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                        reserv: 1,
                    },
                }
            );
            let response = ApiResDecrypt(encResponse.data);
            const data = await response;
            if (data.data !== null || data.data !== "") {
                setBankDetails(processResponse(data.data.bankDetails));
                setAddressPr(processResponse(data.data.addressProof));
                setOthers(processResponse(data.data.others));
                setPan(processResponse(data.data.pan));
            } else {
                console.log("error");
            }
        } catch (err) {
            console.log("Error", err.message);
        }
    };

    const saveObj = async () => {
        function ValueCollect(array) {
            let listingArray = [];
            if (array.length > 0) {
                let Arra = array;
                for (let data of Arra) {
                    listingArray.push(data.value);
                }
            }
            return listingArray;
        }

        let panValue = ValueCollect(paN);
        let addressValue = ValueCollect(address);
        let bankValue = ValueCollect(bank);
        let otherValue = ValueCollect(other);

        try {
            const encResponse = await axios.post(
                `${URL.saveRejections}`,
                AESEncryption({
                    ekycId: localStorage.getItem("ekycId"),
                    clientName: localStorage.getItem("name"),
                    mobile: localStorage.getItem("mobile"),
                    pan: localStorage.getItem("panNo"),
                    rejectedBy: localStorage.getItem("userName"),
                    panObjections: panValue,
                    bankObjections: bankValue,
                    addressObjections: addressValue,
                    otherObjections: otherValue,
                }),

                {
                    headers: {
                        "content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                        reserv: 1,
                    },
                }
            );
            let response = ApiResDecrypt(encResponse.data);

            const data = await response;
            if (data.data == "Mail sent successfully") {
                toast.success(data.data);
                navigate(mainType === "Retail" ? "/retail-home" : "/hni-home");
            } else {
                toast.error(data.message);
            }
        } catch (err) {
            console.log("Error", err.message);
        }
    };

    const handleChange = (data) => {
        setPaN(data || []);
    };

    const handleBankChange = (data) => {
        setBank(data || []);
    };

    const handleAddressChange = (data) => {
        setAddress(data || []);
    };

    const handleOtherChange = (data) => {
        setOther(data);
    };

    function updatedata() {
        setShow(false);
        saveObj();
    }
    function backTohome() {
        navigate(mainType === "Retail" ? "/retail-home" : "/hni-home");
    }

    function openObjModal() {
        setObjPopUp(true);
    }

    useEffect(() => {
        GetObjections();
    }, []);

    return (
        <>
            <div className="card-box bottom-25">
                <div className="section-title-oms card-title">
                    <h2 className="objection-title">Rejection Type</h2>
                    {localStorage.getItem("omsRole")?.toLowerCase() == "admin" ? (
                        <>
                            <div onClick={openObjModal}>
                                <span className="icon-plus">
                                    <img src={addIcon} className="plus-icon" />
                                </span>
                            </div>
                        </>
                    ) : (
                        <>{null}</>
                    )}
                </div>
                <div>
                    <ul className="rejection-type">
                        <li className="rejection-type-item row">
                            <div className="col-md-3 form-group">
                                <h2 className="form-control">PAN</h2>
                            </div>
                            <div className="col-md-9 form-group">
                                <div className="">
                                    <Select
                                        options={pan}
                                        placeholder="Select Pan Objection"
                                        classNamePrefix="react-select"
                                        className="react-select-dropdown form-control"
                                        onChange={handleChange}
                                        isSearchable={true}
                                        // styles={colourStyles}
                                        value={paN}
                                        isMulti
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="rejection-type-item row">
                            <div className="col-md-3 form-group">
                                <h2 className="form-control">Bank Details</h2>
                            </div>
                            <div className="col-md-9 form-group">
                                <div className="">
                                    <Select
                                        options={bankDetails}
                                        onChange={handleBankChange}
                                        classNamePrefix="react-select"
                                        className="react-select-dropdown form-control"
                                        placeholder="Select Bank Details Objection"
                                        isSearchable={true}
                                        value={bank}
                                        isMulti
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="rejection-type-item row">
                            <div className="col-md-3 form-group">
                                <h2 className="form-control">Address Details</h2>
                            </div>
                            <div className="col-md-9 form-group">
                                <div className="">
                                    <Select
                                        options={addressPr}
                                        placeholder="Select Address Details Objection"
                                        classNamePrefix="react-select"
                                        className="react-select-dropdown form-control"
                                        onChange={handleAddressChange}
                                        isSearchable={true}
                                        value={address}
                                        isMulti
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="rejection-type-item row">
                            <div className="col-md-3 form-group">
                                {/* <input type="text" value="Others" className="form-control" /> */}
                                <h2 className="form-control">Others</h2>
                            </div>
                            <div className="col-md-9 form-group">
                                <div className="">
                                    <Select
                                        options={others}
                                        placeholder="Select Others Objection"
                                        classNamePrefix="react-select"
                                        className="react-select-dropdown form-control"
                                        onChange={handleOtherChange}
                                        isSearchable={true}
                                        value={other}
                                        isMulti
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="rejection-btn-wrappper">
                    <button type="submit" className="send-message" onClick={handleOnChange}>
                        Submit
                    </button>
                    <button className="send-message" onClick={backTohome}>
                        Back
                    </button>
                </div>
            </div>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model oms-rejection-modal sure-modal"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">ARE YOU SURE</h2>
                    </Modal.Title>
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => setShow(false)}>
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>

                <div className="button-oms-modal">
                    <button className="oms-close" onClick={() => setShow(false)}>
                        CANCEL
                    </button>
                    <button className="send-message" onClick={() => updatedata()}>
                        OK
                    </button>
                </div>
            </Modal>
            <Modal
                show={objPopUp}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model oms-rejection-modal"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">ADD OBJECTIONS</h2>
                    </Modal.Title>
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => setObjPopUp(false)}>
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-oms form-group">
                        <label htmlFor="name" className="form-label">
                            Rejection Type
                        </label>
                        {/* <input type="text" className="form-control"></input> */}
                        <select
                            className="form-control"
                            id="user_type"
                            name="userType"
                            type="text"
                            onChange={(e) => {
                                UserTypeChange(e);
                            }}
                        >
                            <option value="">Select Document Type</option>
                            {docType.map((role, i) => (
                                <option key={i} value={role.id}>
                                    {role.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-oms form-group">
                        <label className="form-label">Type Objection</label>
                        <textarea
                            rows={5}
                            className="form-control"
                            onChange={(e) => {
                                addObjection(e);
                            }}
                        ></textarea>
                    </div>
                </Modal.Body>
                <div className="button-oms-modal">
                    <button className="oms-close" onClick={() => setObjPopUp(false)}>
                        CANCEL
                    </button>
                    <button className="send-message" onClick={AddNewObjection}>
                        Save Changes
                    </button>
                </div>
            </Modal>
        </>
    );
}

export default RejectionTypeComp;
